export const ENVIRONMENT = {
  LOCAL: "local",
  DEVELOPMENT: "development",
  STAGING: "staging",
  PRODUCTION: "production",
} as const

export const isLocalEnvironment = () => {
  return process.env.APP_ENV === ENVIRONMENT.LOCAL
}

export const isDevelopmentEnvironment = () => {
  return process.env.APP_ENV === ENVIRONMENT.DEVELOPMENT
}

export const isStagingEnvironment = () => {
  return process.env.APP_ENV === ENVIRONMENT.STAGING
}

export const isProductionEnvironment = () => {
  return process.env.APP_ENV === ENVIRONMENT.PRODUCTION
}
